import React, { useEffect } from 'react';

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius: { sm: 6, md: 8, lg: 12 },
  colors: {
    primary: "#0F172A",
    secondary: "#334155",
    muted: "#64748B",
    border: "#E2E8F0",
    bg: "#F8FAFC",
    success: "#059669",
    warning: "#D97706",
    danger: "#DC2626",
    info: "#3B82F6"
  }
};

const Drawer = ({ isOpen, onClose, title, children, footer, width = 440 }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      const handleEscape = (e) => {
        if (e.key === 'Escape') onClose();
      };
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.body.style.overflow = '';
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isOpen, onClose]);
  
  if (!isOpen) return null;
  
  const drawerWidth = isMobile ? '100vw' : width;
  
  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          zIndex: 1000
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: drawerWidth,
          background: UI.colors.white,
          boxShadow: '-4px 0 16px rgba(0,0,0,0.1)',
          zIndex: 1001,
          display: 'flex',
          flexDirection: 'column',
          animation: 'slideIn 0.2s ease'
        }}
      >
        <style>{`
          @keyframes slideIn {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
        `}</style>
        
        {/* Header */}
        <div style={{
          height: 60,
          background: UI.colors.bg,
          borderBottom: `1px solid ${UI.colors.border}`,
          padding: `0 ${UI.spacing.xl}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}>
          <div style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 15,
            fontWeight: 700,
            color: UI.colors.primary
          }}>
            {title}
          </div>
          <button
            onClick={onClose}
            style={{
              width: 32,
              height: 32,
              border: `1px solid ${UI.colors.border}`,
              borderRadius: UI.radius.md,
              background: UI.colors.white,
              cursor: 'pointer',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: 16
            }}
          >
            ✕
          </button>
        </div>
        
        {/* Body */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: UI.spacing.xl
        }}>
          {children}
        </div>
        
        {/* Footer */}
        {footer && (
          <div style={{
            borderTop: `1px solid ${UI.colors.border}`,
            padding: UI.spacing.lg,
            background: UI.colors.white,
            flexShrink: 0
          }}>
            {footer}
          </div>
        )}
      </div>
    </>
  );
};

export default Drawer;